import { FieldRenderProps } from 'react-final-form';

interface SelectFieldProps extends FieldRenderProps<string> {
  options: Array<{ value: string; label: string }>;
  className?: string;
  label?: string;
  id?: string;
}

const SelectField = ({
  input,
  meta,
  options,
  className = '',
  label,
  id,
}: SelectFieldProps) => {
  // Remove native select styling
  const selectStyles = {
    WebkitAppearance: 'none' as const,
    MozAppearance: 'none' as const,
    appearance: 'none' as const,
    backgroundImage: 'none',
  };

  return (
    <div className="relative inline-block">
      <select
        {...input}
        id={id || input.name}
        className={`${className} appearance-none`}
        style={selectStyles}
        aria-invalid={meta.touched && meta.error ? 'true' : 'false'}
        aria-label={label || input.name}
        aria-describedby={
          meta.touched && meta.error ? `${id || input.name}-error` : undefined
        }
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
        <svg
          className="size-3 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    </div>
  );
};

export default SelectField;
